import{setNonEnumProp}from"../utils/descriptors.js";










export const setAggregateErrors=(error,errors)=>{
if(errors===undefined){
return
}

if(!Array.isArray(errors)){
throw new TypeError(`"errors" option must be an array: ${errors}`)
}

setNonEnumProp(error,"errors",errors)
};